module.exports = __webpack_public_path__ + "img/rwap_04.831a17ee.jpg";